import { Typography } from "@material-ui/core";
import React from "react";
import { useAuthenticatedUser } from "../../../utilities/useAuthenticatedUser";
import { LibraryView, useLibrary } from "../LibraryPage";

const placeHolderText = {
    fontFamily: "Roboto, Helvetica",
    fontSize: "15px",
    color: "#5f6368",
    paddingTop: "17px",
}

const placeHolderTextContainer = {
    height: "100%",
    padding: "67px 17px 17px 17px",

}

export function EmptyState(){
    const context = useLibrary();
    const user = useAuthenticatedUser();
    const { activeView } = context

    switch (activeView) {
        case LibraryView.Home:
            return (
                <div style={placeHolderTextContainer}>
                    <Typography style={placeHolderText}>Sermon Maker is a powerful new way to craft better sermons.</Typography>
                    <Typography style={placeHolderText}>
                        To begin, upload your own sermons, or use Sermon Maker's advanced builder with integrated slide deck creation, sermon
                        idea database, and Scripture search.
                    </Typography>
                    <Typography style={placeHolderText}>Create, edit, organize and preach directly from Sermon Maker.</Typography>
                    <Typography style={placeHolderText}>
                        Need more help?{" "}
                        <a href="https://www.sermonmaker.net/help/" rel="noopener noreferrer" target="_blank">
                            Learn more
                        </a>
                    </Typography>
                </div>
            );
        case LibraryView.Recent:
            return (
                <div style={placeHolderTextContainer}>
                    <Typography style={placeHolderText}>
                        Recent view allows you to easily view changes to your sermons and resources.
                    </Typography>
                    <Typography style={placeHolderText}>
                        Your Recent view can also be a helpful way to find that sermon you just created but don't remember the name of.
                    </Typography>
                    <Typography style={placeHolderText}>Create, edit, organize and preach directly from Sermon Maker.</Typography>
                    <Typography style={placeHolderText}>
                        Need more help?{" "}
                        <a href="https://www.sermonmaker.net/help/how-to-view-my-recent-sermons/" rel="noopener noreferrer" target="_blank">
                            Learn more
                        </a>
                    </Typography>
                </div>
            );
        case LibraryView.Search:
            return (
                <div style={placeHolderTextContainer}>
                    <Typography style={placeHolderText}>
                        The search box and search results allow you to locate your resources based on the title.
                    </Typography>
                    <Typography style={placeHolderText}>
                        To perform a search, enter your search criteria in the search field at the top of your library and any matching
                        results will appear listed below.
                    </Typography>
                    <Typography style={placeHolderText}>
                        Need more help?{" "}
                        <a
                            href="https://www.sermonmaker.net/help/how-to-find-your-sermon-in-the-library/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Learn more
                        </a>
                    </Typography>
                </div>
            );
        case LibraryView.Starred:
            return (
                <div style={placeHolderTextContainer}>
                    <Typography style={placeHolderText}>
                        Starred view allows you to organize your current or favorite sermon resources in a list.
                    </Typography>
                    <Typography style={placeHolderText}>
                        Right-click on a sermon file, series, or folder and select Add Star. All starred items will appear in the Starred
                        view. To remove an item from the Starred view, right-click on a starred resource and select Remove Star.
                    </Typography>
                    <Typography style={placeHolderText}>
                        Need more help?{" "}
                        <a href="https://www.sermonmaker.net/help/how-to-star-and-view-sermons/" rel="noopener noreferrer" target="_blank">
                            Learn more
                        </a>
                    </Typography>
                </div>
            );
        case LibraryView.SermonTemplateList:
            return (
                <div style={placeHolderTextContainer}>
                    <Typography style={placeHolderText}>
                        Tired of always having to come up with new, impactful, and engaging content for sermons? Every pastor wants to deliver
                        a powerful, impactful message to their community. We know how tiresome it can get, so we've decided to help.
                    </Typography>
                    <Typography style={placeHolderText}>
                        These premium templates are hand-picked to help give you the inspiration you need. Use as much, or as little as you
                        want. If you like what you've created, feel free to save it as a template, so you can refer back to it as much as you
                        desire.
                    </Typography>
                    {!user.makerSubscription && (
                        <Typography style={placeHolderText}>
                            Unlock a more efficient way to prepare your sermons with our Sermon Maker Standard Plan.
                        </Typography>
                    )}
                    <Typography style={placeHolderText}>
                        Need technical help?{" "}
                        <a href="https://www.sermonmaker.net/help/" rel="noopener noreferrer" target="_blank">
                            Learn more
                        </a>
                    </Typography>
                </div>
            );
        case LibraryView.OfflineAccess:
            return (
                <div style={placeHolderTextContainer}>
                    <Typography style={placeHolderText}>
                        Offline view gives you access to sermons, even without an internet connection.
                    </Typography>
                    <Typography style={placeHolderText}>
                        Right-click on a text document and select Enable Offline. 
                        All offline enabled items will appear in the Offline view. 
                        To remove an item from the Offline view, right-click and select Disable Offline.
                    </Typography>
                    <Typography style={placeHolderText}>
                        Need technical help?{" "}
                        <a href="https://www.sermonmaker.net/help/" rel="noopener noreferrer" target="_blank">
                            Learn more
                        </a>
                    </Typography>
                </div>
            )
        default:
            return null;
    }
}